export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-7-e35ae28fe40ba2b398d8a9276ba01eb1.jpg";